import { normalizeCatalogueLevel, type CatalogueLevel } from "./catalogueLevel";

export async function loadCatalogueLevels(ids: string[]): Promise<Record<string, CatalogueLevel | null>> {
	const unique = [...new Set(ids)];
	const chunks = Array.from({ length: Math.ceil(unique.length / 50) }, (_, i) => unique.slice(i * 50, i * 50 + 50));
	const results = await Promise.all(chunks.map(async (chunk) => {
		const levels: Record<string, CatalogueLevel | null> = {};
		let pending = chunk;
		// Retry a transient failure once. Explicit null is a successful ungraded
		// result; only absent IDs (failed backend chunks) need another request.
		for (let attempt = 0; attempt < 2 && pending.length; attempt++) {
			try {
				const response = await fetch("/catalogue/levels?ids=" + encodeURIComponent(pending.join(",")), {
					credentials: "same-origin", signal: AbortSignal.timeout(5000),
				});
				if (!response.ok) throw new Error("Grades unavailable");
				const data: unknown = await response.json();
				if (data && typeof data === "object" && !Array.isArray(data)) {
					for (const id of pending) if (Object.hasOwn(data, id)) levels[id] = normalizeCatalogueLevel((data as Record<string, unknown>)[id]);
				}
			} catch { /* The bounded retry also covers network errors and unreadable bodies. */ }
			pending = pending.filter((id) => !Object.hasOwn(levels, id));
		}
		// A sustained outage must not leave the catalogue behind an endless skeleton.
		return Object.assign(levels, Object.fromEntries(pending.map((id) => [id, null])));
	}));
	return Object.assign({}, ...results);
}
